import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {CheckBox} from '../../molecules/CheckBox/CheckBox';
import {CommentSpoilerButtonProps} from './CommentSpoilerButtonProps.interface';

export function CommentSpoilerButton({
  isSpoiler,
  onClickSpoiler,
  className,
  ...props
}: CommentSpoilerButtonProps) {
  return (
    <div
      className={twMerge(
        'mx-15pxr inline-flex h-20pxr cursor-pointer items-center space-x-6pxr',
        className
      )}
      onClick={onClickSpoiler}
      {...props}
    >
      <CheckBox checked={isSpoiler} />
      <Text className="font-small1 text-theme-solid-100">
        {t('comment_contains_spoiler')}
      </Text>
    </div>
  );
}
